import { t } from '@lingui/core/macro';
import { Availability, AvailabilityType } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { formatDays } from '@luminovo/frontend-utils';

export function formatAvailabilityWithExtraDays({
    availability,
    additionalLeadTimeDays,
    manufacturingLeadTime,
}: {
    availability: Availability | undefined;
    additionalLeadTimeDays: number | undefined;
    manufacturingLeadTime: number | undefined;
}): string {
    if (availability === null || availability === undefined) {
        return t`Unknown`;
    }
    const additionalLeadTimeDaysOrDefault = additionalLeadTimeDays ?? 0;
    const manufacturingLeadTimeOrDefault = manufacturingLeadTime ?? 0;
    const nonSourcingDays = additionalLeadTimeDaysOrDefault + manufacturingLeadTimeOrDefault;
    switch (availability.type) {
        case AvailabilityType.LeadTime:
            return formatDays(Math.max(availability.days + nonSourcingDays, 0));
        case AvailabilityType.OnOrderWithUnknownLeadTime:
            return t`On order`;
        case AvailabilityType.OnOrder:
            return formatDays(Math.max(availability.days + nonSourcingDays, 0));
        case AvailabilityType.Stock:
            return formatDays(Math.max(nonSourcingDays, 0));
        default:
            /* c8 ignore next */
            assertUnreachable(availability);
    }
}
